import servise from '@/router/axios'

export const fetchMaterialList = (params) => {
  return servise({
    url: '/dspSelfMaterial/list',
    method: 'get',
    params
  })
}

export const getMaterialById = (id) => {
  return servise({
    url: `/dspSelfMaterial/${id}`,
    method: 'get'
  })
}

export const addMaterial = (data) => {
  return servise({
    url: '/dspSelfMaterial/add',
    method: 'post',
    data
  })
}

export const updateMaterial = (data) => {
  return servise({
    url: '/dspSelfMaterial/update',
    method: 'PUT',
    data
  })
}

export const deleteMaterial = (idList) => {
  return servise({
    url: '/dspSelfMaterial/delete',
    method: 'DELETE',
    params: { idList }
  })
}

export const getMaterialListBySlot = (dspSlotId) => {
  return servise({
    url: '/dspSelfMaterial/listBySlot',
    method: 'get',
    params: { dspSlotId }
  })
}

export const updateMaterialStatus = (materialId, status) => {
  return servise({
    url: '/dspSelfMaterial/updateStatus',
    method: 'PUT',
    params: { materialId, status }
  })
}

export const copyMaterial = (materialId, dspSlotId) => {
  return servise({
    url: '/dspSelfMaterial/copy',
    method: 'POST',
    params: { materialId, dspSlotId }
  })
}
